module.exports = __webpack_public_path__ + "static/media/death-drive-otang-remix.5217bad.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/death-drive-otang-remix.mp3
// module id = 7Ahi
// module chunks = 0